const accountPage = [
    {
        path: "/personalProcess",
        redirect:'/personalProcess/realInfo',
        component: () => import("@views/personalAccount/personalProcess.vue"),
        meta: {
            title: "个人开户",
            showBg: false,
            tag:0
        },
        children:[
            {
                path: "realInfo",
                name: "实名信息",
                component: () => import("@views/personalAccount/personalInfo/realInfo.vue"),
                meta:{
                    tag:0,
                }
            },
            {
                path: "realInfoNew",
                name: "实名信息",
                component: () => import("@views/personalAccount/openAccountNew/cardType/realInfoNew.vue"),
                meta:{
                    tag:0,
                    singleHead: true,
                }
            },
            {
                path: "personalInfoChildNew",
                name: "个人相关信息",
                component: () => import("@views/personalAccount/openAccountNew/cardType/personalInfoChildNew.vue"),
                meta: {
                    // tag:1,
                    notReturnBtn:true
                },
            },
            {
                path: "riskAssessmentNew",
                name: "风险测评",
                component: () => import("@views/personalAccount/openAccountNew/cardType/riskAssessmentNew.vue"),
                meta: {
                    title: "个人信息",
                    tag:1,
                    skipStep:{
                        stepName:'riskAssessmentNew'
                    },
                    notReturnBtn:true
                },
            },
            {
                path: "riskResultNew",
                name: "风险测评",
                component: () => import("@views/personalAccount/openAccountNew/cardType/riskResultNew.vue"),
                meta: {
                    title: "个人信息",
                    tag:1,
                    notReturnBtn:true
                },
            },
            {
                path: "bindCardNew",
                name: "绑定银行卡",
                component: () => import("@views/personalAccount/openAccountNew/cardType/bindCardNew.vue"),
                meta: {
                    title: "个人信息",
                    tag:2,
                    skipStep:{
                        stepName:'bindCardNew',
                    },
                    phone:true,
                    notReturnBtn:true
                },
            },
            {
                path: "riskReasonNew",
                name: "风险测评",
                component: () => import("@views/personalAccount/openAccountNew/cardType/riskReasonNew.vue"),
                meta: {
                title: "个人信息",
                },
            },
            {
                path: "investorIdentificationNew",
                name: "投资者类型认定",
                component: () => import("@views/personalAccount/openAccountNew/cardType/investorIdentificationNew.vue"),
                meta:{
                    tag:3,
                    skipStep:{
                        stepName:'investorIdentificationNew'
                    },
                    notReturnBtn:true,
                    keepAlive:true,
                }
            },
            {
                path: "bankSearchListNew",
                name: "支持自动扣款的银行",
                component: () => import("@views/personalAccount/openAccountNew/bankSearchListNew.vue"),
                meta: {
                    title: "个人信息",
                },
            },
            {
                path: "/accountProcessNew",
                name: "开户流程",
                component: () => import("@views/personalAccount/openAccountNew/notCardType/accountProcessNew.vue"),
                meta: {
                    title: "个人开户",
                    keepAlive:true,
                    singleHead: true,
                },
            },










            {
                path: "realPhone",
                name: "手机号实名认证",
                component: () => import("@views/personalAccount/personalInfo/realPhone.vue"),
            },
            {
                path: "notIdentityInfo",
                name: "实名信息",
                component: () => import("@views/personalAccount/noIdentityFile/realInfo.vue"),
                meta:{
                    notTag:0,
                }
            },
            {
                path: "relevantInfo",
                name: "个人相关信息",
                component: () => import("@views/personalAccount/noIdentityFile/relevantInfo.vue"),
                meta:{
                    notTag:1,
                    notReturnBtn:true
                }
            },
            {
                path: "personalInfoChild",
                name: "个人相关信息",
                component: () => import("@views/personalAccount/personalInfo/personalInfoChild.vue"),
                meta: {
                    tag:1,
                    notReturnBtn:true
                },
            },
            {
                path: "identityFile",
                name: "税收身份说明",
                component: () => import("@views/personalAccount/noIdentityFile/identityFile.vue"),
                meta:{
                    notTag:2,
                    taxExplain:true,
                    notReturnBtn:true,
                    skipStep:{
                        stepName:'identityFile'
                    },
                    uploadIcon:true,
                    uploadTitle:'identityFile'
                    // questionName:'identityDes'
                }
            },
            {
                path: "notBankCard",
                name: "绑定银行卡",
                component: () => import("@views/personalAccount/noIdentityFile/bindBank.vue"),
                meta:{
                    notTag:3,
                    notReturnBtn:true,
                    skipStep:{
                        stepName:'notBankCard',
                    },
                    phone:true,
                }
            },
            {
                path: "riskTest",
                name: "风险测评",
                component: () => import("@views/personalAccount/noIdentityFile/riskAssessment.vue"),
                meta:{
                    notTag:4,
                    notReturnBtn:true,
                    skipStep:{
                        stepName:'riskTest',
                    },
                }
            },
            {
                path: "testResult",
                name: "风险测评",
                component: () => import("@views/personalAccount/noIdentityFile/riskResult.vue"),
                meta:{
                    notTag:4,
                    notReturnBtn:true
                }
            },
            {
                path: "typeIdentified",
                name: "投资者类型认定",
                component: () => import("@views/personalAccount/noIdentityFile/investorIdentification.vue"),
                meta:{
                    notTag:5,
                    notReturnBtn:true,
                    skipStep:{
                        stepName:'typeIdentified',
                    },
                }
            },
            {
                path: "identifiedUpload",
                name: "投资者类型认定",
                component: () => import("@views/personalAccount/noIdentityFile/uploadMaterial.vue"),
                meta:{
                    notTag:5,
                    notReturnBtn:true,
                    uploadIcon:true,
                    uploadTitle:'identifiedUpload',
                    skipStep:{
                        stepName:'typeIdentified',
                    },
                    keepAlive:true
                }
            },
            {
                path: "investorIdentification",
                name: "投资者类型认定",
                component: () => import("@views/personalAccount/investorIdentification.vue"),
                meta:{
                    tag:4,
                    skipStep:{
                        stepName:'investorIdentification'
                    },
                    notReturnBtn:true,
                    keepAlive:true,
                }
            },
            {
                path: "uploadMaterial",
                name: "投资者类型认定",
                component: () => import("@views/personalAccount/uploadMaterial.vue"),
                meta: {
                    title: "上传认定材料",
                    showBg: false,
                    tag:4,
                    skipStep:{
                        stepName:'uploadMaterial'//investorIdentification
                    },
                    keepAlive:true,
                    uploadIcon:true
                },
            },
            {
                path: "contactInfo",
                name: "联系信息",
                component: () => import("@views/personalAccount/contactInfo.vue"),
                meta: {
                    title: "个人信息"
                },
            },
            {
                path: "riskAssessment",
                name: "风险测评",
                component: () => import("@views/personalAccount/riskAssessment.vue"),
                meta: {
                    title: "个人信息",
                    tag:2,
                    skipStep:{
                        stepName:'riskAssessment'
                    },
                    notReturnBtn:true
                },
            },
            {
                path: "riskResult",
                name: "风险测评",
                component: () => import("@views/personalAccount/riskResult.vue"),
                meta: {
                    title: "个人信息",
                    tag:2,
                    notReturnBtn:true
                },
            },
            {
                path: "bindCard",
                name: "绑定银行卡",
                component: () => import("@views/personalAccount/bindCard.vue"),
                meta: {
                    title: "个人信息",
                    tag:3,
                    skipStep:{
                        stepName:'bindCard',
                    },
                    phone:true,
                    notReturnBtn:true
                },
            }
            
        ]
    },
    {
        path: "riskQuestionPerson",
        name: "风险匹配说明",
        component: () => import("@views/personalAccount/riskQuestion.vue"),
        meta: {
        title: "个人信息",
        },
    },
    {
        path: "riskReason",
        name: "风险测评",
        component: () => import("@views/personalAccount/riskReason.vue"),
        meta: {
        title: "个人信息",
        },
    },
    {
        path: "riskSeeResult",
        name: "问卷结果",
        component: () => import("@views/personalAccount/riskSeeResult.vue"),
        meta: {
        title: "个人信息",
        },
    },
    {
        path: "identityDes",
        name: "税收身份说明",
        component: () => import("@views/personalAccount/identityDes.vue"),
        meta: {
            title: "个人信息",
            questionName:'identityDes'
        },
    },
    {
        path: "myTaxInformation",
        name: "税收身份声明",
        component: () => import("@views/personalAccount/taxInformation/myTaxInformation.vue"),
        meta: {
            title: "个人中心-税收信息",
            questionName:'myTaxInformation'
        },
    },
    {
        path: "institutionTaxInformation",
        name: "税收身份声明",
        component: () => import("@views/personalAccount/taxInformation/institutionTaxInformation.vue"),
        meta: {
            title: "个人中心-机构税收信息",
            questionName:'institutionTaxInformation'
        },
    },
    {
        path: "entryTax",
        name: "税收身份说明",
        component: () => import("@views/personalAccount/taxEntry.vue"),
        meta: {
            title: "个人信息",
            questionName:'identityDes'
        },
    },
    {
        path: "riskResult1",
        name: "风险测评",
        component: () => import("@views/personalAccount/riskResult1.vue"),
            meta: {
                title: "个人信息",
                notReturnBtn:true
            },
    },
    {
        path: "bankSearchList",
        name: "支持自动扣款的银行",
        component: () => import("@views/personalAccount/bankSearchList.vue"),
        meta: {
            title: "个人信息",
        },
    },
    {
        path: "/searchExample",
        name: "查看示例",
        component: () => import("@views/personalAccount/searchExample.vue"),
        meta: {
            title: "投资者类型认定",
            showBg: false
        },
    },
    {
        path: "/searchExamplePer",
        name: "查看示例",
        component: () => import("@views/personalAccount/searchExample.vue"),
        meta: {
            title: "投资者类型认定",
            showBg: false
        },
    },
    {
        path: "/searchExampleVeri",
        name: "查看示例",
        component: () => import("@views/personalAccount/searchExample.vue"),
        meta: {
            title: "投资者类型认定",
            showBg: false
        },
    },
    {
        path: "/notIdentityExample",
        name: "查看示例",
        component: () => import("@views/personalAccount/searchExample.vue"),
        meta: {
            title: "投资者类型认定",
            showBg: false
        },
    },
    {
        path: "/boundOrgAccount",
        name: "已绑定的机构客户",
        component: () => import("@views/orgAccount/boundOrgAccount.vue"),
        meta: {
            title: "已绑定的机构客户",
        },
    },
    {
        path: "/orgAccountProcess",
        name: "开户流程",
        component: () => import("@views/orgAccount/orgAccountProcess.vue"),
        meta: {
        title: "机构开户",
        keepAlive:true,
        },
    },
    {
        path: "/orgInfo",
        name: "机构信息",
        component: () => import("@views/orgAccount/orgInfo.vue"),
        meta: {
        title: "机构开户",
        },
    },
    {
        path: "/accountProcess",
        name: "开户流程",
        component: () => import("@views/personalAccount/accountProcess.vue"),
        meta: {
            title: "个人开户",
            keepAlive:true
        },
    },
    {
        path: "/selectAccount",
        name: "选择开户主体",
        component: () => import("@views/personalAccount/selectAccount.vue"),
        meta: {
        title: "个人信息",
        },
    },
    {
        path: "/transitPage",
        // name: "选择开户主体",
        component: () => import("@views/other/transitPage.vue"),
        meta: {
        title: "个人信息",
        },
    },
    {
        path: "/bindCard1",
        name: "绑定银行卡",
        component: () => import("@views/personalAccount/bindCard1.vue"),
        meta: {
        title: "个人信息",
        },
    },
    {
        path: "/notIdentityBank",
        name: "绑定银行卡",
        component: () => import("@views/personalAccount/notIdentityBank.vue"),
        meta: {
        title: "非身份证",
        },
    },
    {
        path: "/riskAssessment1",
        name: "风险测评",
        component: () => import("@views/personalAccount/riskAssessment1.vue"),
        meta: {
            title: "个人信息",
        },
    },
    {
        path: "/contactInfo",
        name: "联系信息",
        component: () => import("@views/personalAccount/contactInfo.vue"),
        meta: {
        title: "个人信息"
        },
    },
    {
        path: "/investorIdentification1",
        name: "投资者类型认定",
        component: () => import("@views/personalAccount/investorIdentification1.vue"),
        meta: {
            title: "个人信息",
        },
    },
    {
        path: "/searchOldExample",
        name: "查看示例",
        component: () => import("@views/personalAccount/searchExample.vue"),
        meta: {
            title: "投资者类型认定",
            showBg: false
        },
    },
    {
        path: "/oldInvestors",
        name: "高龄投资者认定",
        component: () => import("@views/personalAccount/oldInvestors.vue"),
        meta: {
            title: "个人中心",
        },
    },
    {
        path: "/oldUploadMaterial",
        name: "高龄投资者认定",
        component: () => import("@views/personalAccount/oldUploadMaterial.vue"),
        meta: {
            title: "个人中心",
            oldValidate:true
        },
    },
    {
        path: "/identityDes1",
        name: "个人税收居民身份声明",
        component: () => import("@views/personalAccount/identityDes1.vue"),
        meta: {
        title: "个人信息",
        questionName:'identityDes'
        },
    },
    {
        path: "/searchIdentityDes",
        name: "个人税收居民身份声明",
        component: () => import("@views/personalAccount/searchIdentityDes.vue"),
        meta: {
        title: "个人信息",
        },
    },
    {
        path: "/uploadMaterial1",
        name: "投资者类型认定",
        component: () => import("@views/personalAccount/uploadMaterial1.vue"),
        meta: {
            title: "个人信息",
            skipStep:{
                stepName:''
            },
            uploadIcon:true
        },
    },
    {
        path: "/permissionsInvestorIdentification",
        name: "投资者类型认定",
        component: () => import("@views/personalAccount/veInvestorIdentification.vue"),
        meta: {
            title: "个人信息",
        },
    },
    {
        path: "/permissionsUploadMaterial",
        name: "投资者类型认定",
        component: () => import("@views/personalAccount/veUploadMaterial.vue"),
        meta: {
            title: "个人信息",
            skipStep:{
                stepName:''
            },
            uploadIcon:true
        },
    },
]
export default accountPage